import { Component, EventEmitter, Input, OnDestroy, OnInit, Output } from "@angular/core";
import { FormGroup } from "@angular/forms";
import { Subject } from "rxjs";
import { distinctUntilChanged, takeUntil } from "rxjs/operators";

@Component({
    selector: "clare-slidetoggle",
    templateUrl: "./clare-slidetoggle.component.html",
    styleUrls: ["./clare-slidetoggle.component.scss"],
})
export class ClareSlidetoggleComponent implements OnInit, OnDestroy {
    @Input() metaData: any;
    @Input() isLoading: boolean;
    @Input() theForm: FormGroup;
    @Input() enableRetry: boolean;
    @Output() getValueEmitter = new EventEmitter<void>();

    private unsubscribe$ = new Subject<void>();

    ngOnInit() {
        const formControl = this.theForm?.controls[this.metaData?.inputName];
        formControl?.valueChanges.pipe(distinctUntilChanged(), takeUntil(this.unsubscribe$)).subscribe(value => {
            if (value === null) {
                formControl.disable({ emitEvent: false });
            } else {
                formControl.enable({ emitEvent: false });
            }
        });
    }

    ngOnDestroy(): void {
        this.unsubscribe$.next(null);
        this.unsubscribe$.complete();
    }
}
